/**
 * Formats a quote number for display, optionally adding a prefix and left-padding with zeros.
 * @param quoteNumber - The raw integer quote number.
 * @param padWidth - Optional pad width; if null/undefined/<=0 the number is returned without padding.
 * @param prefix - Optional prefix string prepended to the formatted number (e.g. "QA" -> "QA0055").
 * @returns The formatted quote number. Numbers wider than padWidth are NOT truncated.
 */
export function formatQuoteNumber(
  quoteNumber: number,
  padWidth?: number | null,
  prefix?: string | null,
): string {
  const padded =
    padWidth && padWidth > 0
      ? String(quoteNumber).padStart(padWidth, "0")
      : String(quoteNumber);
  if (prefix) return `${prefix}${padded}`;
  return padded;
}
